import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Workspace } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

import { CDN_LINKS_LIST_KEY } from '~/hooks/api/useListCdnLinks';

export type UpdateCdnLinkParams = {
  workspaceId: Workspace['id'];
  cdnLinkId: string;
  inactive: boolean;
};

export const useUpdateCdnLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateCdnLinkParams) => callAirApi(() => Workspaces.CdnLinks.update(params)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CDN_LINKS_LIST_KEY],
      });
    },
  });
};
